'use strict';


var isFullyVisible = function (ele, container) {
    var eleRect = ele.getBoundingClientRect();
    var containerRect = container.getBoundingClientRect();

    return eleRect.top > containerRect.top && eleRect.bottom < containerRect.bottom;
};

/**
 * Special Select element using Bootstrap dropdown
 * This code is only for global behavior.
 * Custonmizations and data / html update please handle externally on the page JS module where the select is being implemented for better control.
 */
module.exports = {
    init: function () {
        // To avoid double loops on the special selector, the toggler element outside of the dropdown-list is not dynamic and needs to be populated if dropdown item is already 'selected' on page load.
        $('.special-select').each(function () {
            var $this = $(this);
            var $selectedItem = $this.find('.dropdown-item.selected');
            var $selectorToggler = $this.find('.special-select-toggle');

            if ($selectedItem.length > 0 && !$selectorToggler.is('selected')) {
                $selectorToggler.addClass('selected').html($selectedItem.html());
            }
        });

        // Events fired after CSS transition/DOM changes happened
        $('.special-select').on('shown.bs.dropdown', function () {
            /* If a "selected" item exist inside the menu and it's not visible, scroll to it.
            By default dropdown-menu has a max-height and scroll to avoid viewport issues. */
            var $dropdownMenu = $(this).find('.dropdown-menu');
            var $selectedItem = $dropdownMenu.find('.dropdown-item.selected');

            if ($selectedItem.length > 0 && !isFullyVisible($selectedItem.get(0), $dropdownMenu.get(0))) {
                $selectedItem.get(0).scrollIntoView({
                    block: 'center'
                });
            }
        });
    }
};
